<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form ref="form" lazy-validation style="height: calc(100% - 64px)">
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกลุ่มสิทธิใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ accessAuthorityInit.authority_code }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ accessAuthorityInit.title_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: calc(100% - 128px)">
        <div class="d-flex flex-column" style="height: 100%">
          <v-tabs
            v-model="tab"
            show-arrows
            grow
            @change="handleChangeTabs($event)"
          >
            <v-tab>
              ข้อมูลทั่วไป
              <span class="red--text ml-1"><strong>*</strong></span>
            </v-tab>
            <v-tab>
              ช่วงเวลา
              <span class="red--text ml-1"><strong>*</strong></span>
            </v-tab>
            <v-tab
              :disabled="
                !accessAuthority.authority_uuid ||
                (uiCtrl && !uiCtrl.isEnable('tab:::authority_hardware:list'))
              "
            >
              <div class="mr-1 text-capitalize">Device</div>
              <div class="grey lighten-2 rounded px-1">
                <span class="caption" style="font-weight: bold">
                  {{ accessAuthority.total_authority_hardware }}
                </span>
              </div>
            </v-tab>
            <v-tab
              :disabled="
                !accessAuthority.authority_uuid ||
                (uiCtrl && !uiCtrl.isEnable('tab:::authority_employee:list'))
              "
            >
              <div class="mr-1">พนักงาน</div>
              <div class="grey lighten-2 rounded px-1">
                <span class="caption" style="font-weight: bold">
                  {{ accessAuthority.total_authority_employee }}
                </span>
              </div>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" style="height: 100%">
            <v-tab-item
              class="px-4 py-6"
              style="height: 100%; overflow-y: auto"
            >
              <div>
                <label class="body-2">
                  รหัสกลุ่มสิทธิ์
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  v-model="accessAuthority.authority_code"
                  :rules="[
                    (v) => !!v || 'โปรดระบุรหัสกลุ่มสิทธิ์',
                    (v) =>
                      !v ||
                      (v && v.length <= 10) ||
                      'รหัสกลุ่มสิทธิ์ ต้องน้อยกว่า 10 ตัวอักษร',
                  ]"
                  outlined
                  dense
                  required
                  clearable
                  @change="checkEmpty($event, 'authority_code')"
                >
                </v-text-field>
              </div>
              <div>
                <label class="body-2">
                  คำอธิบาย (ไทย)
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  v-model="accessAuthority.title_th"
                  :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
                  outlined
                  dense
                  required
                  clearable
                  @change="checkEmpty($event, 'title_th')"
                >
                </v-text-field>
              </div>
              <div>
                <label class="body-2">คำอธิบาย (อังกฤษ)</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  v-model="accessAuthority.title_en"
                  outlined
                  dense
                  clearable
                  @change="checkEmpty($event, 'title_en')"
                >
                </v-text-field>
              </div>
              <div>
                <div class="d-flex flex-column">
                  <label class="body-2 mb-1">วันเวลาเริ่มใช้งาน</label>
                  <date-picker
                    v-model="accessAuthority.access_control_start_time"
                    type="datetime"
                    format="DD/MM/YYYY HH:mm"
                    :disabled-date="disabledAfterDateEnd"
                    :disabled-time="disabledAfterDateEnd"
                    style="width: 100%"
                  ></date-picker>
                </div>
                <div class="d-flex flex-column mt-6">
                  <label class="body-2 mb-1">วันเวลาสิ้นสุดใช้งาน</label>
                  <date-picker
                    v-model="accessAuthority.access_control_end_time"
                    type="datetime"
                    format="DD/MM/YYYY HH:mm"
                    :disabled-date="disabledBeforeDateStart"
                    :disabled-time="disabledBeforeDateStart"
                    style="width: 100%"
                  ></date-picker>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item
              class="px-4 py-6"
              style="height: 100%; overflow-y: auto"
            >
              <div>
                <div class="d-flex justify-space-between">
                  <label class="body-2">
                    รหัสช่วงเวลา
                    <span class="red--text"><strong>*</strong></span>
                  </label>
                  <button
                    type="button"
                    :class="`btn-text body-2 mr-2 ${
                      !accessAuthority.timezone.timezone_uuid
                        ? 'grey--text'
                        : ''
                    }`"
                    @click.stop="handleClickView()"
                    :disabled="!accessAuthority.timezone.timezone_uuid"
                  >
                    ดูแผนภาพ
                  </button>
                </div>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  v-model="accessAuthority.timezone"
                  :rules="[
                    (v) => (v && v.timezone_uuid ? true : 'โปรดระบุช่วงเวลา'),
                  ]"
                  :items="
                    timezones.map((timezone) => ({
                      ...timezone,
                      text: `${timezone.timezone_code} - ${timezone.title_th}`,
                    }))
                  "
                  item-text="text"
                  item-value="timezone_uuid"
                  return-object
                  outlined
                  dense
                  :loading="loadingTimezones"
                >
                </v-autocomplete>
              </div>
              <div v-if="accessAuthority.timezone.timezone_uuid">
                <div>
                  <label class="body-2">คำอธิบาย (ไทย)</label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    v-model="accessAuthority.timezone.title_th"
                    outlined
                    dense
                    readonly
                  >
                  </v-text-field>
                </div>
                <div>
                  <label class="body-2">คำอธิบาย (อังกฤษ)</label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    v-model="accessAuthority.timezone.title_en"
                    outlined
                    dense
                    readonly
                  >
                  </v-text-field>
                </div>
                <div v-if="accessAuthority.timezone.timezone_code !== 'TA'">
                  <tabs @selectedTab="handleSelectedTab" fullWidth>
                    <tab
                      v-for="timezoneDetail in timezones.length > 0
                        ? timezones.find(
                            (timezone) =>
                              timezone.timezone_uuid ===
                              accessAuthority.timezone.timezone_uuid
                          ).timezone_detail
                        : []"
                      :key="timezoneDetail.day_type.day_type_id"
                      :title="timezoneDetail.day_type.title_short_th"
                    >
                      <div
                        class="d-flex align-center justify-space-between pb-3"
                      >
                        <div class="d-flex align-center">
                          <label class="mr-2">คัดลอกข้อมูล</label>
                          <div style="width: 120px">
                            <v-select
                              :value="0"
                              style="background-color: white"
                              :items="[
                                { text: '-', value: 0 },
                                { text: 'อาทิตย์', value: 1 },
                                { text: 'จันทร์', value: 2 },
                                { text: 'อังคาร', value: 3 },
                                { text: 'พุธ', value: 4 },
                                { text: 'พฤหัสบดี', value: 5 },
                                { text: 'ศุกร์', value: 6 },
                                { text: 'เสาร์', value: 7 },
                              ]"
                              item-text="text"
                              item-value="value"
                              disabled
                              hide-details
                              outlined
                              dense
                            ></v-select>
                          </div>
                        </div>
                        <div>
                          <v-btn
                            depressed
                            color="primary"
                            class="mr-2"
                            disabled
                          >
                            คัดลอก
                          </v-btn>
                          <v-btn depressed color="error" disabled>
                            ยกเลิก
                          </v-btn>
                        </div>
                      </div>
                      <v-divider></v-divider>
                      <div class="mt-3">
                        <div
                          class="d-flex align-center mb-2"
                          v-for="timezoneTimePeriod in timezoneDetail.timezone_time_period"
                          :key="timezoneTimePeriod.display_order"
                        >
                          <label class="flex-shrink-0 mr-3">
                            ช่วงเวลาที่ {{ timezoneTimePeriod.display_order }}
                          </label>
                          <v-card
                            outlined
                            class="d-flex align-center justify-center flex-grow-1"
                            style="height: 42px"
                          >
                            {{ timezoneTimePeriod.time_period_start }}
                          </v-card>
                          <span class="mx-2">-</span>
                          <v-card
                            outlined
                            class="d-flex align-center justify-center flex-grow-1"
                            style="height: 42px"
                          >
                            {{ timezoneTimePeriod.time_period_end }}
                          </v-card>
                        </div>
                      </div>
                    </tab>
                  </tabs>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item style="height: calc(100% - 185px)">
              <div class="px-4 py-4">
                <div class="d-flex">
                  <v-text-field
                    v-model="authorityDeviceSearch"
                    class="fix-google-chrome mr-2"
                    label="ค้นหา"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    outlined
                    dense
                    hide-details
                    @click:clear="handleAuthorityDeviceSearch"
                    @input="handleAuthorityDeviceSearch"
                  ></v-text-field>
                  <v-autocomplete
                    v-model="authorityDeviceAreaFilter"
                    class="fix-google-chrome"
                    label="พื้นที่"
                    :items="areas"
                    item-text="title_th"
                    item-value="area_uuid"
                    outlined
                    dense
                    clearable
                    @change="handleAuthorityDeviceAreaFilter"
                    :loading="loadingAreas"
                  >
                  </v-autocomplete>
                </div>
                <div class="d-flex justify-space-between">
                  <v-btn
                    @click="$emit('onAddDevice')"
                    class="mr-4"
                    color="primary"
                    rounded
                    depressed
                    :disabled="
                      uiCtrl &&
                      !uiCtrl.isEnable('btn:::authority_hardware:create')
                    "
                  >
                    <v-icon left>mdi-plus</v-icon>
                    <span class="text-capitalize">เพิ่ม Device</span>
                  </v-btn>
                  <div style="width: 260px">
                    <v-select
                      v-model="authorityDeviceSort"
                      :items="[
                        {
                          text: 'เรียงตามรหัส Device',
                          value: 'hardware_code',
                        },
                        { text: 'เรียงตามชื่อ Device', value: 'title_th' },
                      ]"
                      :disabled="authorityDevicePagination.isLoading"
                      item-text="text"
                      item-value="value"
                      filled
                      rounded
                      dense
                      prepend-inner-icon="mdi-sort"
                      hide-details
                      color="grey darken-1"
                      @change="handleChangeAuthorityDeviceSort"
                    ></v-select>
                  </div>
                </div>
              </div>
              <div class="px-4 mb-1">
                <v-btn
                  small
                  depressed
                  @click="onDeleteDeviceOrEmployeeMemberAll('device')"
                  :disabled="
                    accessAuthority.total_authority_hardware === 0 ||
                    (uiCtrl &&
                      !uiCtrl.isEnable('btn:::authority_hardware:delete'))
                  "
                  >ลบทั้งหมด</v-btn
                >
              </div>
              <div
                class="mx-4"
                style="
                  height: 100%;
                  overflow-y: auto;
                  border: 1px solid #bdbdbd;
                "
              >
                <DynamicScroller
                  :items="authorityDeviceMember"
                  :min-item-size="authorityDevicePagination.limit"
                  key-field="hardware_uuid"
                  class="px-2 py-2"
                >
                  <template v-slot="{ item, index, active }">
                    <DynamicScrollerItem
                      :item="item"
                      :active="active"
                      :data-index="index"
                    >
                      <div>
                        <div
                          class="px-2 py-2 d-flex justify-space-between"
                          v-observe-visibility="
                            item.hardware_uuid ===
                              lastAuthorityDeviceMember.hardware_uuid &&
                            !isAuthorityDeviceMemberLastPage
                              ? infiniteScrollHandlerDevice
                              : false
                          "
                        >
                          <div>
                            <div class="body-2">
                              {{ item.hardware_code }} - {{ item.title_th }}
                            </div>
                            <div class="body-2 grey--text">
                              รุ่น: {{ item.hardware_model.title }}
                            </div>
                          </div>
                          <v-btn
                            icon
                            color="grey darken-1"
                            @click="
                              onDeleteDeviceOrEmployeeMember('device', item)
                            "
                            :disabled="
                              (uiCtrl &&
                                !uiCtrl.isEnable(
                                  'btn:::authority_hardware:delete'
                                )) ||
                              item.is_policy_dpc === false
                            "
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                        <v-divider></v-divider>
                      </div>
                    </DynamicScrollerItem>
                  </template>
                </DynamicScroller>
                <div v-if="authorityDevicePagination.isLoading">
                  <div class="px-2">
                    <v-card
                      color="#f5f5f5"
                      v-for="num in 10"
                      :key="num"
                      outlined
                      class="px-4 py-2 mb-2"
                    >
                      <Skeleton width="200px" />
                      <Skeleton :count="1" />
                    </v-card>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item style="height: calc(100% - 185px)">
              <div class="px-4 py-4">
                <div class="d-flex">
                  <v-text-field
                    v-model="authorityEmployeeSearch"
                    class="mr-2"
                    label="ค้นหา"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    outlined
                    dense
                    hide-details
                    @click:clear="handleAuthorityEmployeeSearch"
                    @input="handleAuthorityEmployeeSearch"
                  ></v-text-field>
                  <v-autocomplete
                    v-model="authorityEmployeeOrganizationFilter"
                    class="fix-google-chrome"
                    label="หน่วยงาน"
                    :items="organizations"
                    item-text="title_th"
                    item-value="organization_uuid"
                    outlined
                    dense
                    clearable
                    @change="handleAuthorityEmployeeOrganizationFilter"
                    :loading="loadingOrganizations"
                  >
                  </v-autocomplete>
                </div>
                <div class="d-flex justify-space-between">
                  <v-btn
                    @click="$emit('onAddEmployee')"
                    class="mr-4"
                    color="primary"
                    rounded
                    depressed
                    :disabled="
                      uiCtrl &&
                      !uiCtrl.isEnable('btn:::authority_employee:create')
                    "
                  >
                    <v-icon left>mdi-plus</v-icon>
                    <span class="text-capitalize">เพิ่มพนักงาน</span>
                  </v-btn>
                  <div style="width: 260px">
                    <v-select
                      v-model="authorityEmployeeSort"
                      :items="[
                        {
                          text: 'เรียงตามรหัสพนักงาน',
                          value: 'employee_code',
                        },
                        {
                          text: 'เรียงตามชื่อพนักงาน',
                          value: 'firstname_th',
                        },
                      ]"
                      :disabled="authorityEmployeePagination.isLoading"
                      item-text="text"
                      item-value="value"
                      filled
                      rounded
                      dense
                      prepend-inner-icon="mdi-sort"
                      hide-details
                      color="grey darken-1"
                      @change="handleChangeAuthorityEmployeeSort"
                    ></v-select>
                  </div>
                </div>
              </div>
              <div class="px-4 mb-1">
                <v-btn
                  small
                  depressed
                  @click="onDeleteDeviceOrEmployeeMemberAll('employee')"
                  :disabled="
                    accessAuthority.total_authority_employee === 0 ||
                    (uiCtrl &&
                      !uiCtrl.isEnable('btn:::authority_employee:delete'))
                  "
                  >ลบทั้งหมด</v-btn
                >
              </div>
              <div
                class="mx-4"
                style="
                  height: 100%;
                  overflow-y: auto;
                  border: 1px solid #bdbdbd;
                "
              >
                <DynamicScroller
                  :items="authorityEmployeeMember"
                  :min-item-size="authorityEmployeePagination.limit"
                  key-field="employee_uuid"
                  class="px-2 py-2"
                >
                  <template v-slot="{ item, index, active }">
                    <DynamicScrollerItem
                      :item="item"
                      :active="active"
                      :data-index="index"
                    >
                      <div>
                        <div
                          class="px-2 py-2 d-flex justify-space-between"
                          v-observe-visibility="
                            item.employee_uuid ===
                              lastAuthorityEmployeeMember.employee_uuid &&
                            !isAuthorityEmployeeMemberLastPage
                              ? infiniteScrollHandlerEmployee
                              : false
                          "
                        >
                          <div>
                            <div class="body-2">
                              {{ item.firstname_th }}
                              {{ item.lastname_th }} ({{ item.employee_code }})
                            </div>
                            <div class="body-2 grey--text">
                              {{ item.organization.title_th }}
                            </div>
                          </div>
                          <v-btn
                            icon
                            color="grey darken-1"
                            @click="
                              onDeleteDeviceOrEmployeeMember('employee', item)
                            "
                            :disabled="
                              (uiCtrl &&
                                !uiCtrl.isEnable(
                                  'btn:::authority_employee:delete'
                                )) ||
                              item.is_policy_dpc === false
                            "
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                        <v-divider></v-divider>
                      </div>
                    </DynamicScrollerItem>
                  </template>
                </DynamicScroller>
                <div v-if="authorityEmployeePagination.isLoading">
                  <div class="px-2">
                    <v-card
                      color="#f5f5f5"
                      v-for="num in 10"
                      :key="num"
                      outlined
                      class="px-4 py-2 mb-2"
                    >
                      <Skeleton width="200px" />
                      <Skeleton :count="1" />
                    </v-card>
                  </div>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row class="px-3" justify="space-between" align="center">
          <div>
            <v-btn
              class="primary mr-3"
              depressed
              v-if="formAction === 'add'"
              :disabled="
                !isAccessAuthorityDataChange ||
                (uiCtrl && !uiCtrl.isEnable('btn:::authority:create')) ||
                (uiCtrl && !uiCtrl.isEnable('btn:::authority:update'))
              "
              @click="onSubmit"
              >บันทึกกลุ่มสิทธิ์
            </v-btn>
            <v-btn
              class="primary mr-3"
              depressed
              v-if="formAction === 'edit'"
              :disabled="
                !isAccessAuthorityDataChange ||
                (uiCtrl && !uiCtrl.isEnable('btn:::authority:update'))
              "
              @click="onSave"
              >บันทึกกลุ่มสิทธิ์
            </v-btn>
            <v-btn depressed @click="onReset">ยกเลิก</v-btn>
          </div>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog v-model="dialogView" width="1280">
      <v-card>
        <v-card-title class="body-2 grey lighten-2 d-flex">
          <div class="flex-grow-1 d-flex">
            <div style="width: 280px">
              <div style="color: gray">รหัสช่วงเวลา :</div>
              <div class="body-2">{{ timezone.timezone_code }}</div>
            </div>
            <div>
              <div style="color: gray">คำอธิบาย (ไทย)</div>
              <div class="body-2">{{ timezone.title_th }}</div>
            </div>
          </div>
          <div>
            <v-btn icon @click="dialogView = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="py-6">
          <TimezoneTable :timezoneDetail="timezone.timezone_detail" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDeleteDeviceOrEmployeeMember"
      :loading="confirmDeleteDeviceOrEmployeeLoadingMember"
      :dialogData="confirmDeleteDeviceOrEmployeeDataMember"
      @cancelConfirmDialog="cancelConfirmDeleteDeviceOrEmployeeMember"
      @submitConfirmDialog="submitConfirmDeleteDeviceOrEmployeeMember"
    />
    <ConfirmDialog
      :dialog="confirmDeleteDeviceOrEmployeeMemberAll"
      :loading="confirmDeleteDeviceOrEmployeeMemberAllLoading"
      :dialogData="confirmDeleteDeviceOrEmployeeMemberAllData"
      @cancelConfirmDialog="cancelConfirmDeleteDeviceOrEmployeeMemberAll"
      @submitConfirmDialog="submitConfirmDeleteDeviceOrEmployeeMemberAll"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'
import TimezoneTable from '@/components/TimezoneTable.vue'

export default {
  components: {
    DatePicker,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
    ConfirmDialog,
    TimezoneTable,
    Tabs,
    Tab,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    accessAuthority: {
      type: Object,
    },
    accessAuthorityInit: {
      type: Object,
    },
  },
  data() {
    return {
      authorityDeviceSearch: '',
      authorityDeviceAreaFilter: '',
      authorityDeviceSort: 'hardware_code',
      authorityEmployeeSearch: '',
      authorityEmployeeOrganizationFilter: '',
      authorityEmployeeSort: 'employee_code',
      authorityDevicePagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      authorityEmployeePagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      authorityDeviceMember: [],
      totalAuthorityDeviceMember: 0,
      authorityEmployeeMember: [],
      totalAuthorityEmployeeMember: 0,
      tab: null,
      selectedTab: 0,
      timezone: {
        timezone_code: '',
        title_th: '',
        timezone_detail: [],
      },
      confirmDeleteDeviceOrEmployeeMember: false,
      confirmDeleteDeviceOrEmployeeLoadingMember: false,
      confirmDeleteDeviceOrEmployeeDataMember: {},
      confirmDeleteDeviceOrEmployeeMemberAll: false,
      confirmDeleteDeviceOrEmployeeMemberAllLoading: false,
      confirmDeleteDeviceOrEmployeeMemberAllData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      dialogView: false,
      loadingTimezones: false,
      loadingAreas: false,
      loadingOrganizations: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    lastAuthorityDeviceMember() {
      const [lastItem] = this.authorityDeviceMember.slice(-1)
      return lastItem || {}
    },
    lastAuthorityEmployeeMember() {
      const [lastItem] = this.authorityEmployeeMember.slice(-1)
      return lastItem || {}
    },
    isAuthorityDeviceMemberLastPage() {
      return (
        this.authorityDevicePagination.currentPage ===
        Math.ceil(
          this.totalAuthorityDeviceMember / this.authorityDevicePagination.limit
        )
      )
    },
    isAuthorityEmployeeMemberLastPage() {
      return (
        this.authorityEmployeePagination.currentPage ===
        Math.ceil(
          this.totalAuthorityEmployeeMember /
            this.authorityEmployeePagination.limit
        )
      )
    },
    areas() {
      return this.$store.state.area.areas
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    isAccessAuthorityDataChange() {
      if (
        this.accessAuthority?.authority_code !==
          this.accessAuthorityInit?.authority_code ||
        this.accessAuthority?.title_th !== this.accessAuthorityInit?.title_th ||
        this.accessAuthority?.title_en !== this.accessAuthorityInit?.title_en ||
        JSON.stringify(this.accessAuthority?.access_control_start_time) !==
          JSON.stringify(this.accessAuthorityInit?.access_control_start_time) ||
        JSON.stringify(this.accessAuthority?.access_control_end_time) !==
          JSON.stringify(this.accessAuthorityInit?.access_control_end_time) ||
        this.accessAuthority?.timezone?.timezone_uuid !==
          this.accessAuthorityInit?.timezone?.timezone_uuid
      ) {
        this.$emit('isAccessAuthorityDataChange', true)
        return true
      }
      this.$emit('isAccessAuthorityDataChange', false)
      return false
    },
    timezones() {
      return this.$store.state.timezone.timezones
    },
  },
  watch: {
    accessAuthority: function (value) {
      if (value && value.authority_uuid) {
        if (this.tab === 2) {
          this.authorityDeviceMember = []
          this.authorityDevicePagination.currentPage = 1
          this.getAuthorityDeviceMember()
        } else if (this.tab === 3) {
          this.authorityEmployeeMember = []
          this.authorityEmployeePagination.currentPage = 1
          this.getAuthorityEmployeeMember()
        }
      }
    },
    formShow: function (value) {
      if (!value) {
        this.tab = 0
      }
    },
  },
  methods: {
    ...mapActions({
      fetchTimezones: 'timezone/fetchTimezones',
      fetchAuthorityDeviceMember: 'accessAuthority/fetchAuthorityDeviceMember',
      fetchAuthorityEmployeeMember:
        'accessAuthority/fetchAuthorityEmployeeMember',
      deleteAuthorityDeviceMember:
        'accessAuthority/deleteAuthorityDeviceMember',
      deleteAuthorityEmployeeMember:
        'accessAuthority/deleteAuthorityEmployeeMember',
      fetchAreas: 'area/fetchAreas',
      fetchOrganizations: 'organization/fetchOrganizations',
      addAccessAuthority: 'accessAuthority/addAccessAuthority',
      editAccessAuthority: 'accessAuthority/editAccessAuthority',

      fetchAccessAuthority: 'accessAuthority/fetchAccessAuthority',
    }),
    disabledAfterDateEnd(date) {
      if (!this.accessAuthority.access_control_end_time) {
        return false
      }
      return date > new Date(this.accessAuthority.access_control_end_time)
    },
    disabledBeforeDateStart(date) {
      if (!this.accessAuthority.access_control_start_time) {
        return false
      }
      return date < new Date(this.accessAuthority.access_control_start_time)
    },
    handleAuthorityDeviceAreaFilter() {
      this.authorityDeviceMember = []
      this.authorityDevicePagination.currentPage = 1
      this.getAuthorityDeviceMember()
    },
    handleAuthorityEmployeeOrganizationFilter() {
      this.authorityEmployeeMember = []
      this.authorityEmployeePagination.currentPage = 1
      this.getAuthorityEmployeeMember()
    },
    onDeleteDeviceOrEmployeeMember(type, item) {
      const text = type === 'device' ? 'Device' : 'พนักงาน'
      const value =
        type === 'device'
          ? `${item.hardware_code} - ${item.title_th}`
          : `${item.employee_code} - ${item.firstname_th} ${item.lastname_th}`

      this.confirmDeleteDeviceOrEmployeeMember = true
      this.confirmDeleteDeviceOrEmployeeDataMember = {
        title: 'ยืนยันการลบ',
        text: `คุณต้องการลบ ${text}`,
        value: `${value}`,
        item: { type, data: { ...item } },
      }
    },
    cancelConfirmDeleteDeviceOrEmployeeMember() {
      this.confirmDeleteDeviceOrEmployeeMember = false
    },
    async submitConfirmDeleteDeviceOrEmployeeMember({ type, data }) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDeleteDeviceOrEmployeeLoadingMember = true

        if (type === 'device') {
          await this.deleteAuthorityDeviceMember({
            company_uuid,
            authority_uuid: this.accessAuthority?.authority_uuid,
            body: {
              hardware_uuid: data.hardware_uuid,
            },
            params: {
              dpc: 'access-authority-hardware-post-delete-to-list-access-authority-hardware',
            },
          })
        } else if (type === 'employee') {
          await this.deleteAuthorityEmployeeMember({
            company_uuid,
            authority_uuid: this.accessAuthority?.authority_uuid,
            body: {
              employee_uuid: data.employee_uuid,
            },
            params: {
              dpc: 'access-authority-employee-post-delete-to-list-access-authority-employee',
            },
          })
        }

        const accessAuthority = await this.fetchAccessAuthority({
          company_uuid,
          authority_uuid: this.accessAuthority.authority_uuid,
        })

        this.$store.commit(
          'accessAuthority/EDIT_ACCESS_AUTHORITY',
          accessAuthority
        )

        this.$emit('formActionCompleted', {
          formAction: 'deviceOrEmployeeDelete',
          formType: 'accessAuthorityForm',
          accessAuthority,
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 4000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDeleteDeviceOrEmployeeLoadingMember = false
        this.confirmDeleteDeviceOrEmployeeMember = false
      }
    },
    handleAuthorityDeviceSearch: _.debounce(function () {
      this.authorityDeviceMember = []
      this.authorityDevicePagination.currentPage = 1
      this.getAuthorityDeviceMember()
    }, 1000),
    handleAuthorityEmployeeSearch: _.debounce(function () {
      this.authorityEmployeeMember = []
      this.authorityEmployeePagination.currentPage = 1
      this.getAuthorityEmployeeMember()
    }, 1000),
    handleChangeAuthorityDeviceSort() {
      this.authorityDeviceMember = []
      this.authorityDevicePagination.currentPage = 1
      this.getAuthorityDeviceMember()
    },
    handleChangeAuthorityEmployeeSort() {
      this.authorityEmployeeMember = []
      this.authorityEmployeePagination.currentPage = 1
      this.getAuthorityEmployeeMember()
    },
    handleChangeTabs(tab) {
      if (tab === 1) {
        this.getTimezones()
      } else if (tab === 2) {
        this.authorityDeviceMember = []
        this.authorityDevicePagination.currentPage = 1
        this.getAuthorityDeviceMember()
        this.getAreas()
      } else if (tab === 3) {
        this.authorityEmployeeMember = []
        this.authorityEmployeePagination.currentPage = 1
        this.getAuthorityEmployeeMember()
        this.getOrganizations()
      }
    },
    async getTimezones() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'access-authority-to-list-timezone',
            sort: 'timezone_code,asc',
            is_display_time_attendance: true,
          },
        }

        this.loadingTimezones = true

        await this.fetchTimezones(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingTimezones = false
      }
    },
    async getAreas() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.loadingAreas = true

        const payload = {
          company_uuid,
          params: {
            dpc: 'access-authority-hardware-to-list-area',
          },
        }

        await this.fetchAreas(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingAreas = false
      }
    },
    async getOrganizations() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.loadingOrganizations = true

        const payload = {
          company_uuid,
          params: {
            dpc: 'access-authority-employee-to-list-organization',
            sort: 'title_th:asc',
          },
        }

        await this.fetchOrganizations(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingOrganizations = false
      }
    },
    async getAuthorityDeviceMember() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          authority_uuid: this.accessAuthority?.authority_uuid,
          params: {
            dpc: 'access-authority-hardware-to-list-access-authority-hardware',
            area_uuid: this.authorityDeviceAreaFilter || undefined,
            search: this.authorityDeviceSearch || undefined,
            sort: `${this.authorityDeviceSort},asc`,
            limit: `${this.authorityDevicePagination.limit},${
              (this.authorityDevicePagination.currentPage - 1) *
              this.authorityDevicePagination.limit
            }`,
            is_policy_tag: true,
          },
        }

        this.authorityDevicePagination.isLoading = true

        await this.fetchAuthorityDeviceMember(payload)
        const { total, data } =
          this.$store.state.accessAuthority.authorityDeviceMember
        this.totalAuthorityDeviceMember = total
        this.setAuthorityDeviceMember(data)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.authorityDevicePagination.isLoading = false
      }
    },
    async getAuthorityEmployeeMember() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          authority_uuid: this.accessAuthority?.authority_uuid,
          params: {
            dpc: 'access-authority-employee-to-list-access-authority-employee',
            organization_uuid:
              this.authorityEmployeeOrganizationFilter || undefined,
            search: this.authorityEmployeeSearch || undefined,
            sort: `${this.authorityEmployeeSort},asc`,
            limit: `${this.authorityEmployeePagination.limit},${
              (this.authorityEmployeePagination.currentPage - 1) *
              this.authorityEmployeePagination.limit
            }`,
            is_policy_tag: true,
          },
        }

        this.authorityEmployeePagination.isLoading = true

        await this.fetchAuthorityEmployeeMember(payload)
        const { total, data } =
          this.$store.state.accessAuthority.authorityEmployeeMember
        this.totalAuthorityEmployeeMember = total
        this.setAuthorityEmployeeMember(data)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.authorityEmployeePagination.isLoading = false
      }
    },
    handleSelectedTab(i) {
      this.selectedTab = i
    },
    handleClickView() {
      this.dialogView = true
      const timezoneSelected = this.timezones.find(
        (timezone) =>
          timezone.timezone_uuid === this.accessAuthority.timezone.timezone_uuid
      )
      this.timezone = {
        timezone_code: timezoneSelected.timezone_code,
        title_th: timezoneSelected.title_th,
        timezone_detail: timezoneSelected.timezone_detail.map((timezone) => {
          return {
            timezone_detail_uuid: timezone.timezone_detail_uuid,
            timezone_time_period: timezone.timezone_time_period.map((item) => {
              if (item.time_period_start && item.time_period_end) {
                return {
                  time_period_start: item.time_period_start,
                  time_period_end: item.time_period_end,
                  start:
                    Number(item.time_period_start.split(':')[0]) * 44 +
                    (Number(item.time_period_start.split(':')[1]) / 60) * 44,
                  end:
                    (Number(item.time_period_end.split(':')[0]) -
                      Number(item.time_period_start.split(':')[0])) *
                      44 +
                    Number(item.time_period_end.split(':')[1] / 60) * 44 -
                    Number(item.time_period_start.split(':')[1] / 60) * 44,
                }
              }
            }),
          }
        }),
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.accessAuthority[field] = value.trim()
      }
    },
    onDeleteDeviceOrEmployeeMemberAll(type) {
      this.confirmDeleteDeviceOrEmployeeMemberAll = true
      this.confirmDeleteDeviceOrEmployeeMemberAllData = {
        title: 'ยืนยันการลบ',
        text:
          type === 'device'
            ? 'คุณต้องการลบ Device ทั้งหมด'
            : 'คุณต้องการลบพนักงานทั้งหมด',
        value: '',
        item: { type, data: this.accessAuthority },
      }
    },
    cancelConfirmDeleteDeviceOrEmployeeMemberAll() {
      this.confirmDeleteDeviceOrEmployeeMemberAll = false
    },
    async submitConfirmDeleteDeviceOrEmployeeMemberAll({ type, data }) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDeleteDeviceOrEmployeeMemberAllLoading = true

        if (type === 'device') {
          await this.deleteAuthorityDeviceMember({
            company_uuid,
            authority_uuid: this.accessAuthority?.authority_uuid,
            body: {
              clear_all: true,
            },
            params: {
              dpc: 'access-authority-hardware-post-delete-to-list-access-authority-hardware',
            },
          })
        } else if (type === 'employee') {
          await this.deleteAuthorityEmployeeMember({
            company_uuid,
            authority_uuid: this.accessAuthority?.authority_uuid,
            body: {
              clear_all: true,
            },
            params: {
              dpc: 'access-authority-employee-post-delete-to-list-access-authority-employee',
            },
          })
        }

        if (type === 'device') {
          this.authorityDeviceMember = []
          this.authorityDevicePagination.currentPage = 1
        } else if (type === 'employee') {
          this.authorityEmployeeMember = []
          this.authorityEmployeePagination.currentPage = 1
        }

        const accessAuthority = await this.fetchAccessAuthority({
          company_uuid,
          authority_uuid: this.accessAuthority.authority_uuid,
        })

        this.$store.commit(
          'accessAuthority/EDIT_ACCESS_AUTHORITY',
          accessAuthority
        )

        this.$emit('formActionCompleted', {
          formAction: 'deviceOrEmployeeDeleteAll',
          formType: 'accessAuthorityForm',
          accessAuthority,
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 4000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDeleteDeviceOrEmployeeMemberAllLoading = false
        this.confirmDeleteDeviceOrEmployeeMemberAll = false
      }
    },
    async onSubmit() {
      if (
        !this.accessAuthority.authority_code ||
        !this.accessAuthority.title_th
      ) {
        this.tab = 0
        this.$refs?.form.validate()

        return
      } else if (!this.accessAuthority.timezone?.timezone_uuid) {
        this.tab = 1
        this.handleChangeTabs(1)
        this.$refs?.form.validate()

        return
      }

      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          body: {
            authority_code: this.accessAuthority.authority_code,
            title_th: this.accessAuthority.title_th,
            title_en: this.accessAuthority?.title_en,
            access_control_start_time: this.accessAuthority
              .access_control_start_time
              ? moment
                  .utc(this.accessAuthority.access_control_start_time)
                  .format()
              : undefined,
            access_control_end_time: this.accessAuthority
              .access_control_end_time
              ? moment
                  .utc(this.accessAuthority.access_control_end_time)
                  .format()
              : undefined,
            timezone_uuid: this.accessAuthority.timezone?.timezone_uuid,
          },
        }

        this.$store.state.loading = true

        if (this.formAction === 'add' && this.accessAuthority.authority_uuid) {
          const accessAuthority = await this.editAccessAuthority({
            ...payload,
            authority_uuid: this.accessAuthority.authority_uuid,
          })
          this.$emit('formActionCompleted', {
            formAction: this.formAction,
            formType: 'accessAuthorityForm',
            accessAuthority,
          })

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 4000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } else {
          const accessAuthority = await this.addAccessAuthority(payload)
          this.$emit('formActionCompleted', {
            formAction: this.formAction,
            formType: 'accessAuthorityForm',
            accessAuthority,
          })

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 4000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    async onSave() {
      if (
        !this.accessAuthority.authority_code ||
        !this.accessAuthority.title_th
      ) {
        this.tab = 0
        this.$refs?.form.validate()

        return
      } else if (!this.accessAuthority.timezone?.timezone_uuid) {
        this.tab = 1
        this.handleChangeTabs(1)
        this.$refs?.form.validate()

        return
      }

      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          authority_uuid: this.accessAuthority.authority_uuid,
          body: {
            authority_code: this.accessAuthority.authority_code,
            title_th: this.accessAuthority.title_th,
            title_en: this.accessAuthority?.title_en,
            access_control_start_time: this.accessAuthority
              .access_control_start_time
              ? moment
                  .utc(this.accessAuthority.access_control_start_time)
                  .format()
              : undefined,
            access_control_end_time: this.accessAuthority
              .access_control_end_time
              ? moment
                  .utc(this.accessAuthority.access_control_end_time)
                  .format()
              : undefined,
            timezone_uuid: this.accessAuthority.timezone?.timezone_uuid,
          },
        }

        this.$store.state.loading = true

        const accessAuthority = await this.editAccessAuthority(payload)
        this.$emit('formActionCompleted', {
          formAction: this.formAction,
          formType: 'accessAuthorityForm',
          accessAuthority,
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 4000,
          message: 'แก้ไขข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    onClose() {
      if (this.isAccessAuthorityDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('onReset')
        this.$refs.form.resetValidation()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('onReset')
      this.$refs.form.resetValidation()
    },
    onReset() {
      this.$emit('onReset')
      this.$refs.form.resetValidation()
    },
    async getNextAuthorityDeviceMember() {
      try {
        this.authorityDevicePagination.currentPage += 1

        await this.getAuthorityDeviceMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextAuthorityEmployeeMember() {
      try {
        this.authorityEmployeePagination.currentPage += 1

        await this.getAuthorityEmployeeMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setAuthorityDeviceMember(devices) {
      this.authorityDeviceMember = [...this.authorityDeviceMember, ...devices]
    },
    setAuthorityEmployeeMember(employees) {
      this.authorityEmployeeMember = [
        ...this.authorityEmployeeMember,
        ...employees,
      ]
    },
    infiniteScrollHandlerDevice(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextAuthorityDeviceMember()
      }
    },
    infiniteScrollHandlerEmployee(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextAuthorityEmployeeMember()
      }
    },
  },
}
</script>
